import React, { useContext } from 'react';
import { TeamMemberGridContext } from '../../TeamMemberGrid/TeamMemberGridContext';

const useTeamMemberFilterCheckbox = ( filterKey ) => {
  const { filters, setFilters, checked, setChecked } = useContext( TeamMemberGridContext );

  // Scroll grid to top
  const scrollGridToTop = () => {
    const gridEl = document.querySelector( '.team-member-grid' );
    if ( gridEl ) gridEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // Generate initial object for checkbox reset button
  const initialObj = checked?.[filterKey] || {};

  const handleCheckboxChange = ( e, isChecked ) => {
    const value = e.target.value;
    // Double check this
    isChecked = e.target.checked;

    setChecked( prev => ({
      ...prev,
      [filterKey]: {
        ...( prev[filterKey] || {}),
        [value]: isChecked
      }
    }) );

    const prevValues = filters?.[filterKey] || [];
    const newValues = isChecked
      ? [ ...prevValues, value ]
      : prevValues.filter( v => v !== value );

    setFilters({
      ...filters,
      [filterKey]: newValues
    });

    scrollGridToTop();
  };

  const resetContextFilter = () => {
    setChecked({
      ...checked,
      [filterKey]: {}
    });
    setFilters({
      ...filters,
      [filterKey]: []
    });

    setTimeout( () => {
      scrollGridToTop();
    }, 100 );
  };

  const resetAllContextFilters = () => {
    setChecked({
      imprints: {},
      categories: {}
    });
    setFilters({
      imprints: [],
      categories: []
    });
  };

  return {
    checkedFilter: checked?.[ filterKey ],
    handleCheckboxChange,
    resetContextFilter,
    resetAllContextFilters,
    initialObj
  };
};

export default useTeamMemberFilterCheckbox;
